"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyPress = void 0;
var react_1 = require("react");
var useEventListener_1 = require("./useEventListener");
/**
 * Indicates whether or not a key has been pressed.
 * @param targetKey The key to listen for.
 */
var useKeyPress = function (targetKey) {
    var _a = (0, react_1.useState)(false), keyPressed = _a[0], setKeyPressed = _a[1];
    var kewDownHandler = (0, react_1.useMemo)(function () { return function (_a) {
        var key = _a.key;
        if (key === targetKey) {
            setKeyPressed(true);
        }
    }; }, [targetKey]);
    (0, useEventListener_1.useEventListener)({
        type: 'keydown',
        listener: kewDownHandler,
    });
    var keyUpHandler = (0, react_1.useMemo)(function () { return function (_a) {
        var key = _a.key;
        if (key === targetKey) {
            setKeyPressed(false);
        }
    }; }, [targetKey]);
    (0, useEventListener_1.useEventListener)({
        type: 'keyup',
        listener: keyUpHandler,
    });
    return keyPressed;
};
exports.useKeyPress = useKeyPress;
